import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

import MobileSplideCarousel from './MobileSplideCarousel';
import DesktopSplideCarousel from './DesktopSplideCarousel';

const Title = styled(Typography)`
  font-size: 36px;
  font-weight: 500;
  line-height: 39.6px;
  letter-spacing: -0.03em;
  text-align: center;

  span {
    background: linear-gradient(99.92deg, #9F2DEB 18.57%, #6200A3 71.77%);
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
  }

  @media (width >= 768px) {
    font-size: 40px;
    line-height: 48px;
  }
`;

function DoubtsCarousel() {
  return (
    <Box
      tag="section"
      marginVertical={{ xs: '43px', lg: '80px' }}
    >
      <Title
        variant="heading4"
        marginBottom={{ xs: '40px', lg: '80px' }}
        whiteSpace="pre-line"
      >
        {'¿Tienes alguna de \n'}
        <span> estas dudas</span>
        ?
      </Title>
      <MobileSplideCarousel />
      <DesktopSplideCarousel />
    </Box>
  );
}

export default DoubtsCarousel;
